import { PatientEntityType } from "@/lib/supabase/supabaseTypes";
import { User } from "lucide-react";
import { usePatientStore } from "../../store/Patient";

interface VendorJobPatientInfoProps {
	patient: PatientEntityType;
}

export const VendorJobPatientInfo: React.FC<VendorJobPatientInfoProps> = ({
	patient,
}) => {
	const patientName = usePatientStore((state) => state.patientName);

	const formatName = () => {
		return patientName(patient) || "Unbekannt";
	};

	const formatBirthDate = () => {
		if (!patient.birth_date) return null;
		return new Date(patient.birth_date).toLocaleDateString("de-CH");
	};

	const formatGender = () => {
		if (!patient.gender) return null;
		switch (patient.gender.toLowerCase()) {
			case "m":
			case "male":
			case "männlich":
				return "Männlich";
			case "f":
			case "female":
			case "weiblich":
				return "Weiblich";
			default:
				return patient.gender;
		}
	};

	return (
		<div className="rounded-lg border border-stone-200 p-4">
			<div className="flex items-center gap-2 mb-3">
				<User size={16} className="text-stone-400" />
				<h3 className="font-medium text-stone-800">Patient</h3>
			</div>
			<div className="space-y-2 text-sm">
				<div className="flex justify-between">
					<span className="text-stone-500">Name</span>
					<span className="text-stone-800">{formatName()}</span>
				</div>
				{patient.code && (
					<div className="flex justify-between">
						<span className="text-stone-500">Code</span>
						<span className="text-stone-800">{patient.code}</span>
					</div>
				)}
				{formatBirthDate() && (
					<div className="flex justify-between">
						<span className="text-stone-500">Geburtsdatum</span>
						<span className="text-stone-800">
							{formatBirthDate()}
						</span>
					</div>
				)}
				{formatGender() && (
					<div className="flex justify-between">
						<span className="text-stone-500">Geschlecht</span>
						<span className="text-stone-800">{formatGender()}</span>
					</div>
				)}
			</div>
		</div>
	);
};
